import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/components/admin/Dashboard';
import Login from '@/components/admin/auth/Login';
import AppNotFound from '@/common/layout/pages/AppNotFound';
import AppForbidden from '@/common/layout/pages/AppForbidden';
import AppError from '@/common/layout/pages/AppError';

// e-register
import Solicitante from '@/components/eRegister/solicitante/Solicitante';
import Tramite from '@/components/eRegister/tramite/Tramite';
import TramiteDoc from '@/components/eRegister/tramiteDoc/TramiteDoc';
import Historial from '@/components/eRegister/tramiteDoc/Historial';
import ParaFirma from '@/components/eRegister/tramiteDoc/ParaFirma';
import Pago from '@/components/eRegister/pago/Pago';

// e-apostilla
import Entidad from '@/components/eApostilla/entidad/Entidad';
import Documento from '@/components/eApostilla/documento/Documento';
import Reporte from '@/components/eApostilla/reportes/Reporte';

// System
import Account from '@/components/admin/account/Account';
import Usuario from '@/components/admin/usuario/Usuario';
import Auxiliar from '@/components/admin/auxiliar/Auxiliar';
import Modulo from '@/components/admin/modulo/Modulo';
import Preferencias from '@/components/admin/preferencias/Preferencias';
import Log from '@/components/admin/Log';

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/usuarios',
      name: 'Usuario',
      component: Usuario
    },
    {
      path: '/auxiliares',
      name: 'Auxiliar',
      component: Auxiliar
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/entidades',
      name: 'Entidad',
      component: Entidad
    },
    {
      path: '/parametros',
      name: 'Preferencias',
      component: Preferencias
    },
    {
      path: '/documentos',
      name: 'Documento',
      component: Documento
    },
    {
      path: '/modulos',
      name: 'Módulo',
      component: Modulo
    },
    {
      path: '/logs',
      name: 'Logs',
      component: Log
    },
    {
      path: '/solicitantes',
      name: 'Solicitante',
      component: Solicitante
    },
    {
      path: '/tramites',
      name: 'Tramite',
      component: Tramite
    },
    {
      path: '/tramitesDoc',
      name: 'TramiteDoc',
      component: TramiteDoc
    },
    {
      path: '/pagos',
      name: 'Pago',
      component: Pago
    },
    {
      path: '/historial',
      name: 'Historial',
      component: Historial
    },
    {
      path: '/para_firma',
      name: 'Para Firma',
      component: ParaFirma
    },
    {
      path: '/reportes',
      name: 'Reporte',
      component: Reporte
    },
    {
      path: '/404',
      component: AppNotFound
    },
    {
      path: '/403',
      component: AppForbidden
    },
    {
      path: '/500',
      component: AppError
    },
    {
      path: '*',
      component: AppNotFound
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js